/* Template coordinates share a 600 × 650 design surface. Text boxes are safe print areas. */
window.HiveJerseyTemplates = [
  {
    id: 'short-sleeve', label: 'NRL Jersey', group: 'NRL',
    outline: 'M205 80 Q300 100 395 80 L420 110 Q480 130 510 180 L570 340 Q530 375 475 375 L460 325 Q445 440 465 590 Q300 635 135 590 Q155 440 140 325 L125 375 Q70 375 30 340 L90 180 Q120 130 180 110 Z',
    collar: 'M205 80 Q300 100 395 80 L420 110 Q300 150 180 110 Z',
    nameBox: { x: 180, y: 173, width: 240, height: 65 },
    numberBox: { x: 175, y: 268, width: 250, height: 270 },
    hanger: { x: 300, y: 95 }
  },
  {
    id: 'singlet', imageBox: {x:145,y:85,width:310,height:524}, label: 'Basketball Jersey', group: 'Basketball',
    outline: 'M178 85 L232 85 Q238 143 300 150 Q362 143 368 85 L422 85 Q401 186 450 258 L455 592 Q300 626 145 592 L150 258 Q199 186 178 85 Z',
    collar: 'M232 85 Q238 143 300 150 Q362 143 368 85 L380 85 Q370 153 300 163 Q230 153 220 85 Z',
    nameBox: { x: 180, y: 180, width: 240, height: 65 },
    numberBox: { x: 175, y: 268, width: 250, height: 270 },
    hanger: { x: 202, y: 94 }
  },
  {
    id: 'afl-singlet', label: 'AFL Jersey', group: 'AFL',
    imageBox: {x:145,y:85,width:310,height:524},
    outline: 'M178 85 L232 85 L300 154 L368 85 L422 85 Q401 186 450 258 L455 592 Q300 626 145 592 L150 258 Q199 186 178 85 Z',
    collar: 'M232 85 L300 154 L368 85 L382 85 L300 171 L218 85 Z',
    nameBox: { x: 180, y: 180, width: 240, height: 65 },
    numberBox: { x: 175, y: 268, width: 250, height: 270 },
    hanger: { x: 202, y: 94 }
  }
];
